import "./ColorLabel.scss";
import block from "bem-cn";
import { useAppDispatch } from "../../app/hooks";
import { changeBusyList } from "../Filter/FilterSlice";
import { getColor } from "./ColorLabel.utils";

const b = block("ColorLabel");

type Props = {
  text: string | number;
};

const ColorLabel = ({ text = "text" }: Props) => {

  const dispatch = useAppDispatch();

  const onHandleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    dispatch(changeBusyList([text]));
  };

  return (
    <div onClick={onHandleClick} className={b({ busy: getColor(text) })}>
      {typeof text === 'string' ? text : text+'%'}
    </div>
  );
};

export default ColorLabel;
